import React, { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// ✅ Use DesktopDatePicker — always renders icon regardless of screen size
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import colors from "assets/theme/base/colors";

const MDDatePicker = (props) => {
  const [open, setOpen] = useState(false);
  const { datePicker } = colors;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        name={props.name}
        disablePast={props.disablePast}
        disableFuture={props.disableFuture}
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          width: props?.width ?? "100%",
          "& fieldset": {
            border: "0",
            borderBottom: "1px solid",
            borderRadius: "0",
          },
          "& .MuiFormLabel-root": {
            color: `${datePicker.color}`,
            position: "absolute",
            left: "-14px",
          },
          "& .MuiInputBase-input": {
            padding: props.padding ? `${props.padding} !important` : undefined,
            paddingLeft: !props.padding ? "0px !important" : undefined,
          },
        }}
        onChange={(date) => props.onChange(date)}
        value={dayjs(props.value)}
        className="datePicker__Input"
        onBlur={props.onBlur}
        minDate={props?.minDate}
        format="DD-MM-YYYY"
        label={
          <span>
            {props.label} {props.required && <span style={{ color: "red" }}>*</span>}
          </span>
        }
        slotProps={{
          actionBar: {
            actions: ["clear", "accept"],
          },
          openPickerButton: {
            onClick: () => setOpen(true),
          },
        }}
        variant="standard"
      />
    </LocalizationProvider>
  );
};

MDDatePicker.propTypes = {
  name: PropTypes.string,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string, PropTypes.object]),
  onBlur: PropTypes.func,
  label: PropTypes.string,
  width: PropTypes.number,
  minDate: PropTypes.string,
  required: PropTypes.bool,
};

export default MDDatePicker;
